class Feature {
  constructor(geoJsonFeature, layerName, layerDispalyName) {
    this._layerName = layerName;
    this._layerDispalyName = layerDispalyName;
    this._properties = geoJsonFeature.properties;
    this._geometry = geoJsonFeature.geometry;
  }

  get innerId() {
    return `${this._key}${this._layerName}`;
  }

  get key() {
    return this._properties.key;
  }

  get fullName() {
    return this._properties.full_name;
  }

  get layerName() {
    return this._layerName;
  }

  get layerDisplayName() {
    return this._layerDispalyName;
  }

  get infoSetKey() {
    return this._properties.info_set_key;
  }

  get aliasType() {
    return this._properties.aliastype;
  }

  get properties() {
    const filteredProperties = [];
    for (let property in this._properties) {
      if (this._properties.hasOwnProperty(property)) {
        filteredProperties.push({
          name: property,
          value: this._properties[property],
        });
      }
    }
    return filteredProperties;
  }

  mappingProperties(mappings) {
    const mapProperties = [
      {
        name: 'Местоположение',
        value: `${this.latLon.lat}, ${this.latLon.lon}`,
        title: 'Широта, Долгота',
      },
    ];
    mappings.forEach((map) => {
      if (this._properties.hasOwnProperty(map.name)) {
        mapProperties.push({
          name: map.description,
          value: this._properties[map.name],
        });
      }
    });
    return mapProperties;
  }

  get geometry() {
    return this._geometry;
  }

  get latLon() {
    return {
      lat: this._properties.centroid.coordinates[1],
      lon: this._properties.centroid.coordinates[0],
    };
  }
}

export default Feature;
